<template>
  <div class="terms_div">
    <button
      @click="goToExternalLink('https://www.emot.jp/miyagase_kiyaku.html')"
    >
      利用規約
    </button>

    <div style="text-align: center; margin: 10px 0">
      <input
        id="accept-terms"
        class="checkbox"
        type="checkbox"
        @click="turmCheckToggle = !turmCheckToggle"
      />
      <label for="accept-terms" class="checkbox"
        ><span style="font-weight: bold">利用規約に同意する</span>
      </label>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";
export default {
  name: "TheDemandTerms",
  props: {
    turmCheckToggle: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const turmCheckToggle = useVModel(props, "turmCheckToggle");
    return {
      turmCheckToggle,
    };
  },
};
</script>
<style lang="scss">
.terms_div {
  margin: 10px auto;
}

.terms_div button {
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  width: 95%;
  margin: 10px auto 10px;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
  display: block;
  color: black;
}
</style>
